import { useMantineTheme } from '@mantine/core';

import dt from '~/domains/contest/domains/manage/domains/common/testing.const';

import type { FormattedErrors } from '../../../context/utils/formatZodErrors';
import type { FormValues } from '../../../types/FormValues';

import { DescriptorsMap } from './constants';
import type { TableModalColumnType, TableModalRowDataType, TableModalRowType } from './types';
import type { TableModalValue } from './types/common';

export function TableCellSwitch({
  allErrors,
  allValues,
  cell,
  column,
  row,
  sectionKey,
  value,
  onChange,
}: {
  allErrors: FormattedErrors;
  allValues: FormValues;
  cell: TableModalRowDataType;
  column: TableModalColumnType;
  row: TableModalRowType;
  sectionKey: string;
  value: TableModalValue;
  onChange: (columnKey: string, newValue: unknown, skipTouched?: boolean) => void;
}) {
  const theme = useMantineTheme();
  const descriptor = DescriptorsMap[column.type];
  if (!descriptor) {
    // eslint-disable-next-line no-console
    console.log(`Unknown column type: '${column.type}'`);
    return null;
  }

  return (
    <td data-test-id={dt.table.body.cell} style={{ borderBottom: theme.colors.gray[1] }}>
      <descriptor.Cell
        // @ts-expect-error Typescript can't infer column
        column={column}
        // @ts-expect-error Typescript can't infer cell
        cell={cell}
        row={row}
        value={value?.[row.key]?.[column.key]}
        allValues={allValues}
        allErrors={allErrors}
        sectionKey={sectionKey}
        onChange={(newValue, skipTouched?: boolean) => onChange(column.key, newValue, skipTouched)}
      />
    </td>
  );
}
